export function ajaxSubmitForm ($form, successCallback, successCallbackContext, extraData) {
  $form
    .find('.form-errors')
    .hide()
    .empty()

  $form.block()

  // Prepare data for submission
  const data = Object.assign(
    serializedArrayToObject($form.serializeArray()),
    extraData
  )

  $.ajax({
    type: 'POST',
    dataType: 'json',
    url: window.app.ajaxUrl,
    data: data,
    success: (data) => {
      $form.unblock()
      successCallback.apply(successCallbackContext, [data, $form])
    },
  })
}

function serializedArrayToObject (array) {
  const object = {}
  array.forEach(function (element) {
    object[element.name] = element.value
  })
  return object
}



// WEBPACK FOOTER //
// ./scripts/util/forms.js